import { digitsOnly } from './rows';

// Shorter fragments are noise (list numbering, extensions), not numbers.
const MIN_DIGITS = 4;

/**
 * Splits pasted text on tab, comma, semicolon or newline and keeps only the
 * digits of each entry, so "+61 2 9876 5432" becomes "61298765432".
 *
 * @returns {string[]} unique digit strings, in pasted order
 */
export const parsePastedNumbers = (text = '') => [
    ...new Set(
        text
            .split(/[\t,;\r\n]+/)
            .map(digitsOnly)
            .filter((digits) => digits.length >= MIN_DIGITS),
    ),
];

/** One "+digits" per line, the format the textarea is normalised to. */
export const formatPastedNumbers = (numbers) =>
    numbers.map((digits) => `+${digits}`).join('\n');

/**
 * Matches pasted numbers to rows exactly, digit for digit including the
 * country code, so a list of 15 numbers never selects more than 15.
 *
 * @returns {{ found: string[], notFound: string[], matchedIds: Set }}
 */
export const matchPastedNumbers = (numbers, rows) => {
    const rowsByDigits = new Map(rows.map((row) => [row.digits, row]));
    const found = [];
    const notFound = [];
    const matchedIds = new Set();

    numbers.forEach((digits) => {
        const row = rowsByDigits.get(digits);
        if (row) {
            found.push(digits);
            matchedIds.add(row.id);
        } else {
            notFound.push(digits);
        }
    });

    return { found, notFound, matchedIds };
};
